module.exports = __webpack_public_path__ + "assets/img/37_1487.a550db56.jpg";